// extracted by mini-css-extract-plugin
module.exports =  {"root":"i3pDDS9XigXY56T9nIa6"};